import HeaderFooterLayout from 'layouts/HeaderFooterLayoutAdmin';
import React from 'react';
import WellhubUnitsHistory from 'components/AdminPanel/WellhubUnitsHistory';

const AdminWellhubUnitsHistoryPage = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <WellhubUnitsHistory {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default AdminWellhubUnitsHistoryPage;
